<template>
  <div class="addProduct-concontainer container">
    <!-- 头部标题 -->
    <div class="header">
      <van-nav-bar title="新增产品"
                   class="title">
        <img slot="left"
             class="img"
             src="@/assets/back.png"
             @click="$router.back()"/>
      </van-nav-bar>
    </div>
    <!-- 表单区域 -->
    <van-form @submit="onSubmit"
              class="form">
      <!--基本信息-->
      <div class="box">
        <img src="@/assets/star.png"
             alt="必填"
             width="10"
             height="10"
             class="star">
        <span class="name">类型</span>
      </div>
      <input type="textarea"
             class="input" v-model="typeStation"
             @click="typeShowPicker = true"
             placeholder="请输入" onfocus="this.blur();">
      <van-popup v-model="typeShowPicker" position="bottom">
        <van-picker show-toolbar :columns="typeColumns" @cancel="typeShowPicker = false" @confirm="onTypeConfirm"
                    @change="onTypeChange"/>
      </van-popup>
      <div class="box">
        <img src="@/assets/star.png"
             alt="必填"
             width="10"
             height="10"
             class="star">
        <span class="name">分类</span>
      </div>
      <input type="textarea"
             class="input" v-model="product.cname"
             @click="showPicker = true"
             placeholder="请输入" onfocus="this.blur();">
      <van-popup v-model="showPicker" position="bottom">
        <van-picker show-toolbar :columns="columns" @cancel="showPicker = false" @confirm="onConfirm"
                    @change="onChange"/>
      </van-popup>
      <div class="box">

        <span class="name">产品名称</span>
      </div>
      <input type="textarea"
             class="input" v-model="product.name"
             placeholder="请输入">
      <div class="box">
        <img src="@/assets/star.png"
             alt="必填"
             width="10"
             height="10"
             class="star">
        <span class="name">品牌</span>
      </div>
      <input type="text"
             class="input" v-model="product.brand"
             placeholder="请输入">
      <div class="box">
        <img src="@/assets/star.png"
             alt="必填"
             width="10"
             height="10"
             class="star">
        <span class="name">型号</span>
      </div>
      <input type="text"
             class="input" v-model="product.model"
             placeholder="请输入">
      <div class="box">
        <img src="@/assets/star.png"
             alt="必填"
             width="10"
             height="10"
             class="star">
        <span class="name">规格/封装</span>
      </div>
      <input type="text" v-model="product.packages"
             class="input"
             placeholder="请输入">
      <div class="box">
        <img src="@/assets/star.png"
             alt="必填"
             width="10"
             height="10"
             class="star">
        <span class="name">单位</span>
      </div>
      <input type="text"
             class="input" v-model="product.unit"
             placeholder="请输入">
      <div class="box">
        <img src="@/assets/star.png"
             alt="必填"
             width="10"
             height="10"
             class="star">
        <span class="name">最小包装数量</span>
      </div>
      <input type="text"
             onkeyup='this.value=this.value.replace(/\D/gi,"")'
             class="input" v-model="product.unitNumber"
             placeholder="请输入">
      <div class="box">
        <img src="@/assets/star.png"
             alt="必填"
             width="10"
             height="10"
             class="star">
        <span class="name">重量</span>
      </div>
      <input type="text"
             onkeyup='this.value=this.value.replace(/\D/gi,"")'
             class="input" v-model="product.scale"
             placeholder="请输入">
      <div class="box">
        <img src="@/assets/star.png"
             alt="必填"
             width="10"
             height="10"
             class="star">
        <span class="name">价格</span>
      </div>
      <input type="text"
             onkeyup="{if(this.value=='') this.value='0';if((/^((\d+)(\.\d{0,5})?)?$/).test(this.value)) this.oldValue=this.value; else this.value=this.oldValue;}"
             onkeydown="{if(window.event.keyCode==13) window.event.keyCode=9;}"
             onchange="{if(this.value=='') this.value='0';this.value=this.value.replace(/\.$/,'');}"
             class="input" v-model="product.realPrice"
             placeholder="请输入">
      <div class="box">
        <img src="@/assets/star.png"
             alt="必填"
             width="10"
             height="10"
             class="star">
        <span class="name">货期</span>
      </div>
      <div class="input" style="border: none">
        <van-radio-group v-model="product.isExist" direction="horizontal" style="margin-left: 10px;">
          <van-radio :name="0" checked-color="red">现货</van-radio>
          <van-radio :name="1" checked-color="red">货期</van-radio>
        </van-radio-group>
      </div>
      <div style="display: flex" v-if="product.isExist==1">
        <input type="text"
               style="width: 90%"
               onkeyup='this.value=this.value.replace(/\D/gi,"")'
               class="input" v-model="product.delivery"
               placeholder="请输入">
        <div class="input" style="border: none">天</div>
      </div>

      <div class="box">
        <img src="@/assets/star.png"
             alt="必填"
             width="10"
             height="10"
             class="star">
        <span class="name">是否含税</span>
      </div>
      <div class="input" style="border: none">
        <van-radio-group v-model="product.isTax" direction="horizontal" style="margin-left: 10px;">
          <van-radio :name="0" checked-color="red">否</van-radio>
          <van-radio :name="1" checked-color="red">是</van-radio>
        </van-radio-group>
      </div>
      <!--阶梯价格-->
      <div class="box">
        <span class="name">阶梯价格</span>
      </div>
      <div class="table_box_big">
        <div class="table_box">
          <table class="table" border="0" style="table-layout:fixed">
            <!-- 表头 -->
            <thead>
            <tr>
              <th>起订数量</th>
              <th>结束数量</th>
              <th>金额</th>
              <th>操作</th>
            </tr>
            </thead>
          </table>
          <div class="table_tbody_box">
            <table class="table" border="0" width="100%" cellspacing="10">
              <tbody>
              <tr v-for="(item,index) in product.productLadderList" :key="index">
                <td>
                  <input type="text" onkeyup='this.value=this.value.replace(/\D/gi,"")' class="input" v-model="item.startCount">
                  <!--<page-input v-model="item.startCount" class="input"/>-->
                </td>
                <td>
                  <input type="text" onkeyup='this.value=this.value.replace(/\D/gi,"")' class="input" v-model="item.endCount">
                  <!--<page-input v-model="item.endCount" class="input"/>-->
                </td>
                <td>
                  <page-input v-model="item.money" class="input"/>
                </td>
                <td style="width: 120px;display: flex">
                  <van-button type="danger" size="mini" native-type="button" @click="add">添加</van-button>
                  <van-button type="warning" size="mini" native-type="button" @click="remove(index,item)">删除
                  </van-button>
                </td>
              </tr>
              <tr v-if="product.productLadderList.length<3">
                <td colspan="4">
                  <!--<span @click="add">添加</span>-->
                  <img src="@/assets/addRed.png" width="21" height="21" @click="add"/>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!--缩略图-->
      <!--<div class="box">-->
      <!--<img src="@/assets/star.png"-->
      <!--alt="必填"-->
      <!--width="10"-->
      <!--height="10"-->
      <!--class="star">-->
      <!--<span class="name">封面图</span>-->
      <!--</div>-->
      <!--<div class="image">-->
      <!--<div class="item" v-for="(item,index) in fileList" :key="index">-->
      <!--<img :src="item"  alt="图片" class="imgPreview">-->
      <!--<van-icon name="close" @click="delImg(index)" class="delte"/>-->
      <!--</div>-->
      <!--</div>-->
      <!--<van-uploader class="uploader"-->
      <!--:after-read="afterRead"-->
      <!--:accept="accept"/>-->

      <!--商品相册-->
      <div class="box">
        <img src="@/assets/star.png"
             alt="必填"
             width="10"
             height="10"
             class="star">
        <span class="name">商品相册</span>
      </div>
      <div class="image">
        <div class="item" v-for="(item,index) in fileList2" :key="index">
          <img :src="item" alt="图片" class="imgPreview">
          <van-icon name="close" @click="delImg2(index)" class="delte"/>
        </div>
      </div>
      <van-uploader class="uploader"
                    :after-read="afterRead2"
                    :accept="accept"/>

      <!--商品参数-->
      <!--<div class="box">-->
      <!--<span class="name">商品参数(宽度)</span>-->
      <!--<input type="number"-->
      <!--class="input" v-model="product.wide"-->
      <!--placeholder="请输入">-->
      <!--</div>-->
      <!--<div class="box">-->
      <!--<span class="name">商品参数(厚度)</span>-->
      <!--<input type="number"-->
      <!--class="input" v-model="product.thickness"-->
      <!--placeholder="请输入">-->

      <!--</div>-->
      <!--<div class="box">-->
      <!--<span class="name">商品参数(高度)</span>-->
      <!--<input type="number"-->
      <!--class="input" v-model="product.longs"-->
      <!--placeholder="请输入">-->

      <!--</div>-->
      <!--描述-->
      <div class="box">
        <span class="name">描述</span>
      </div>
      <van-field class="textarea"
                 rows="2" v-model="product.detail"
                 autosize
                 type="textarea"
                 maxlength="200"
                 placeholder="请输入"/>
      <!-- <div class="box">
        上传产品规格书 (PDF)文件
      </div>
      <div class="pdf"
           @click="$router.push('/business/addProduct/book')">
        <img src="@/assets/file1.png"
             alt="必填"
             width="33px">
        <span>上传文件</span>
        <img src="@/assets/right.png"
             alt="必填"
             class="right">
      </div> -->
      <van-button type="default"
                  class="button">保存
      </van-button>
    </van-form>
  </div>
</template>

<script>
  import {image} from '@/api/file'
  import {treeMenu} from '@/api/category'
  import {
    getShopProductList,
    saveShopProduct,
    getShopCategoryList,
    getShopProductPage,
    getShopProduct
  } from '@/api/product'
  const getIndex = ((arr,item)=>{
    for(var i in arr){
      if(arr[i] == item){
        return i;
      };
    };
  });
  export default {
    name: 'addProduct',
    data() {
      return {

        typeStation: "",
        typeShowPicker: false,
        typeColumns: ['电子元器件', '电子产品', '其他产品'],

        station: "",
        showPicker: false,
        columns: [],
        menuTree: [],
        provinceList: [],
        cityList: [],
        countyList: [],

        // 文件预览地址
        fileList: [],
        fileList2: [],
        accept: 'image/*',
        product: {
          id: undefined, // 主键ID
          storeId: undefined,
          type: undefined,
          typeName: undefined,
          cid: undefined,
          name: undefined,
          price: undefined,
          realPrice: undefined,
          model: undefined,
          sp: undefined,
          packages: undefined,
          brand: undefined,
          image: undefined,
          detail: undefined,
          remark: undefined,
          stock: undefined,
          rebate: undefined,
          isNew: 0,
          isHot: 0,
          isTax: 0,
          isExist: 0,
          isEnable: 0,
          status: 0,
          productLadderList: []
        }
      }
    },
    created() {
      var user = localStorage.getItem('storeInfo')
      user = JSON.parse(user)
      this.product.uid = user.id
      if (this.$route.query.pid != undefined) {
        getShopProduct({id: this.$route.query.pid}).then(res => {
          if (res.success) {
            this.product = res.data
            this.typeStation = this.$enums.ProductType[this.product.type]
            this.fileList2 = this.product.albumPics.split(',')
            if (this.fileList2.length > 0) {
              this.fileList.push(this.fileList2[0])
            }
          } else {
            this.$toast.fail(res.msg)
          }
        }).catch(err => {

        })
      }
      this.treeMenu()
    },
    methods: {
      add() {
        let productLadderList = this.product.productLadderList;
        if (productLadderList.length < 3) {
          productLadderList.push({startCount: 0, endCount: 0, money: 0})
        } else {
          this.$toast.fail("最多只能添加三条")
        }
      },
      remove(index, row) {
        let productLadderList = this.product.productLadderList;
        if (productLadderList.length === 1) {
          productLadderList.pop();
          productLadderList.push({
            count: 0,
            discount: 0,
            price: 0
          })
        } else {
          productLadderList.splice(index, 1);
        }
      },
      onTypeConfirm(value) {
        if (value){
          let index = getIndex(this.typeColumns,value);
          this.product.type = index;
          this.product.cid = ""
          this.product.cname = ""
        }
        this.typeStation = value;
        this.typeShowPicker = false;
        this.treeMenu()
      },
      onTypeChange(picker, values, index) {
        this.product.type = index;
        this.product.cid = ""
        this.product.cname = ""
      },
      treeMenu() {
        treeMenu({type: this.product.type}).then(res => {
          if (res.success) {
            this.menuTree = res.data.menuTree
            this.cityList = this.menuTree[0].children
            let citys = res.data.menuTree
            // 默认展示一级的数据

            this.columns = [
              {
                values: citys,
                className: "column1"
              },
              {
                values: citys[0].children ? citys[0].children : [],
                className: "column2"
              },
              {
                values: citys[0].children[0].children ? citys[0].children[0].children : [],
                className: "column3"
              }
            ]
          }

        })
      },
      onConfirm(value) {
        const compact = arr => arr.filter(Boolean); // 三级联动 去除没值的，比如只有两级
        const result = compact(value);
        let str = "";  // 呈现页面显示  /xxx/xxx/xxx
        result.forEach(item => {
          if (!str) {
            str = item.text;
          } else {
            str += "/" + item.text;
          }
        });
        this.station = str;
        this.showPicker = false;

        const end = result[result.length - 1]; // 一般都是取最后一个id给后台的
        const id = end.id;
        const name = end.name;
        this.product.cid = id
        this.product.cname = name
      },
      onChange(picker, values, index) {

        let ColumnIndex = picker.getColumnIndex(index);
        console.log("第" + index + "列", "第" + ColumnIndex + "个");

        if (index == 0) {
          this.cityList = this.menuTree[ColumnIndex].children
          if (this.cityList.length > 0) {
            picker.setColumnValues(1, this.cityList);
            picker.setColumnValues(2, this.cityList[0].children || []);
          } else {
            picker.setColumnValues(1, []);
            picker.setColumnValues(2, []);
          }
        }

        if (index == 1) {
          this.countyList = this.cityList[ColumnIndex].children
          picker.setColumnValues(index + 1, this.countyList || []);
        }
      },
      onSubmit() {
        if (!this.typeStation) {
          this.$toast.fail("请选择类型");
          return;
        }
        if (!this.product.cname) {
          this.$toast.fail("请输入分类");
          return;
        }
        if (!this.product.name) {
          this.$toast.fail("请输入名称");
          return;
        }
        if (!this.product.brand) {
          this.$toast.fail("请输入品牌");
          return;
        }
        if (!this.product.model) {
          this.$toast.fail("请输入型号");
          return;
        }
        if (!this.product.packages) {
          this.$toast.fail("请输入封装");
          return;
        }
        if (!this.product.unit) {
          this.$toast.fail("请输入单位");
          return;
        }
        if (!this.product.unitNumber) {
          this.$toast.fail("请输入最小包装数量");
          return;
        }
        if (!this.product.realPrice) {
          this.$toast.fail("请输入价格");
          return;
        }
        if (this.fileList2.length == 0) {
          this.$toast.fail("请上传图片");
          return;
        }
        this.product.image = this.fileList2[0]

        var albumPics = ''
        for (var i = 0; i < this.fileList2.length; i++) {
          albumPics += this.fileList2[i] + ','
        }
        albumPics = albumPics.substring(0, albumPics.length - 1)
        this.product.albumPics = albumPics
        this.product.source = 1
        this.product.status = 0
        this.product.storeId = localStorage.getItem('storeId')
        saveShopProduct(this.product).then(res => {
          if (res.success) {
            this.$toast.success('添加成功'); //上传一张之后压入这个数组
            setTimeout(() => {
              this.$router.go(-1)
            }, 2500)
          } else {
            this.$toast.fail(res.msg)
          }
        }).catch(err => {

        })
      },
      // 文件上传完毕时触发
      afterRead(file) {
        this.upload(file);
      },
      upload(file) {
        let formData = new FormData()
        formData.append('file', file.file)
        image(formData).then(res => {
          if (res.success) {
            this.fileList = []
            this.fileList.push(res.data); //上传一张之后压入这个数组
          } else {
            this.$toast.fail(res.msg)
          }
        }).catch(err => {

        })
      },
      delImg(index) {
        // 删除指定下标的图片对象
        if (isNaN(index) || index >= this.fileList.length) {
          return false
        }
        let tmp = []
        for (let i = 0, len = this.fileList.length; i < len; i++) {
          if (this.fileList[i] !== this.fileList[index]) {
            tmp.push(this.fileList[i])
          }
        }
        this.fileList = tmp
      },
      afterRead2(file) {
        this.upload2(file);
      },
      upload2(file) {
        let formData = new FormData()
        formData.append('file', file.file)
        image(formData).then(res => {
          if (res.success) {
            this.fileList2.push(res.data); //上传一张之后压入这个数组
          } else {
            this.$toast.fail(res.msg)
          }
        }).catch(err => {

        })
      },
      delImg2(index) {
        this.fileList2.splice(index, 1)
        // 删除指定下标的图片对象
        // if (isNaN(index) || index >= this.fileList.length) {
        //   return false
        // }
        // let tmp = []
        // for (let i = 0, len = this.fileList.length; i < len; i++) {
        //   if (this.fileList2[i] !== this.fileList[index]) {
        //     tmp.push(this.fileList[i])
        //   }
        // }
        // this.fileList = tmp
      },
    }
  }
</script>

<style lang="less" scoped>
  .addProduct-concontainer {
    input::-webkit-input-placeholder {
      color: #acacac;
    }
    img {
      vertical-align: middle;
    }
    .title {
      height: 44px;
      background-color: #f3f3f3;
      .img {
        width: 21px;
        height: 21px;
      }
    }
    .form {
      color: #999;
      padding: 0 16px;
      .box {
        margin-top: 17px;
        .star {
          margin: 0 10px;
        }
        .name {
          font-size: 16px;
          color: #999;
        }
      }
      .input {
        margin-top: 8px;
        width: 92%;
        height: 20px;
        border: 1px solid rgba(243, 243, 243, 1);
        border-radius: 4px;
        padding: 10px;
        font-size: 16px;
        font-weight: 400;
        line-height: 21px;
      }
      .textarea {
        height: 200px;
        border: 1px solid #eee;
        margin-top: 10px;
      }
      .table_box_big {
        overflow-x: scroll;
        overflow-y: hidden;
        position: relative;
        min-height: 200px;
        height: auto;
      }
      .table_box {
        /*overflow: hidden;*/
        position: absolute;
      }
      .table_tbody_box {
        height: 300px;
        overflow: scroll;
      }
      table thead tr th {
        width: 100px;
        height: 30px;
        text-align: center;
        word-break: keep-all;
        padding: 2px 10px;
        font-size: 13px;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);

      }
      table tbody tr td {
        width: 100px;
        height: 30px;
        line-height: 30px;
        border: 1px solid #eeeeee;
        text-align: center;
        word-break: keep-all;
        padding: 2px 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 13px;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        //border:#CCCCCC 1px solid;
        .input {
          width: 80px;
          border: none;
          padding: 0;
          margin: 0;
        }
      }
    }
    .uploader {
      margin-top: 10px;
    }
    .button {
      width: 100%;
      background-color: #f40442;
      color: #fff;
      margin-top: 20px;
      margin-bottom: 19px;
      border-radius: 4px;
    }

    .pdf {
      position: relative;
      margin-top: 16px;

      .right {
        width: 14px;
        height: 14px;
        position: absolute;
        top: 8px;
        right: 0;
      }
    }
  }

  .image {
    padding: 10px 16px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    box-sizing: border-box;
    width: 100%;
    padding: 10px 0px;
    overflow: hidden;
    .item {
      display: block;
      width: 80px;
      height: 80px;
      border-radius: 8px;
      position: relative;
      margin: 0 8px 8px 0;
      cursor: pointer;
      .imgPreview {
        width: 80px;
        height: 80px;
      }
      .delte {
        position: absolute;
        top: -8px;
        right: -8px;
        color: #969799;
        font-size: 18px;
        background-color: #fff;
        border-radius: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/business/product/addProduct.vue